module.exports = __webpack_public_path__ + "static/media/JOHN HAGELIN.47cf9d63.jpg";